import { AbstractControl, ValidationErrors } from '@angular/forms';

export const validatePhone = (value: string): boolean =>
  /^\+(\d{1,3})[\s-]?(\d{3}[\s-]?\d{3}[\s-]?\d{3}|\d{2}[\s-]?\d{3}[\s-]?\d{2}[\s-]?\d{2})$/g.test(value);

const PhoneNumberValidator = (formControl: AbstractControl): ValidationErrors | null => {
  const value = formControl && (formControl.value as string);

  if (!value) {
    return {};
  }
  
  const phoneNumber = !validatePhone(value);

  if (!phoneNumber) {
    return {};
  }

  return { phoneNumber };
};

export default PhoneNumberValidator;
